// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__8Q1Bt","header":"Messages_header__19_x8"};